// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__ZgGDS","right":"Footer_right__NcuEG","buttons":"Footer_buttons__MWPe_"};